// Typelizer digest 65184addf45dd2a1dd53878f9e434eef
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /educators/teachers/:teacher_id/relief/bookings/:booking_id/students */
  index: (
    params: { teacherId: string | number; bookingId: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/bookings/:booking_id/students', params, options),
    method: 'get',
  }),

  /** GET /educators/teachers/:teacher_id/relief/bookings/:booking_id/students/:id */
  show: (
    params: { teacherId: string | number; bookingId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/educators/teachers/:teacher_id/relief/bookings/:booking_id/students/:id', params, options),
    method: 'get',
  }),
}
